const MONTH_IN_MILLISECONDS = 30 * 24 * 60 * 60 * 1000;

interface ComputeAlertToDisplayParams {
  creditCardExpiriesAt?: Date;
  failedPayment: boolean;
  overdueInvoice: boolean;
}

export const computeAlertToDisplay = ({ creditCardExpiriesAt, failedPayment, overdueInvoice }: ComputeAlertToDisplayParams) => {
  if (!creditCardExpiriesAt && !failedPayment && !overdueInvoice) return null;

  if (failedPayment) {
    return 'paymentFailed';
  }

  if (overdueInvoice) {
    return 'invoiceOverdue';
  }

  if (creditCardExpiriesAt && (creditCardExpiriesAt.getTime() - Date.now() < MONTH_IN_MILLISECONDS || creditCardExpiriesAt.getTime() < Date.now())) {
    return 'creditCardExpiriesSoon';
  }

  return null;
};
